import React from 'react';

const Button = ({ icon, text, onClick, className = "", children }) => {
  // Only use the provided className, no base styles
  return (
    <button 
      className={className}
      onClick={onClick}
    >
      {icon && <span className="mr-2 text-lg">{icon}</span>}
      {text && <span className="text-base">{text}</span>}
      {children}
    </button>
  );
};

export default Button;